module.exports = __webpack_public_path__ + "img/x.d626b750.png";